import React from 'react'
import CustomButton from '../shared/customButton/CustomButton';
import { setSelectedSearchBoxTab } from '../redux/actions/homeActions';
import { useHistory } from 'react-router';
import { useAppDispatch } from '../redux/hooks';
import heroImage from './../assets/images/heroImage3.webp';
import CustomCard from '../shared/customCard/CustomCard';
import './viaFaq.scss';
import {Helmet} from "react-helmet-async";

const questions = [
  {
    question: 'Where do VIA Rail go?',
    answer: <p><a href="https://www.viarail.ca/en/explore-our-destinations/trains" target="_blank" rel="noreferrer"> Via Rail Routes</a></p>
  },
  {
    question: `Does my ticket include a seat reservation?`,
    answer: <p> Seats are assigned in Ecomomy and Business Class on certain trains. If your e-Ticket does not display a seat number you are free to choose your own. Sleeping accommodations are always assigned. </p>
  },
  {
    question: 'Do I have to buy a ticket for an infant? ',
    answer: <p>Babies and infants under 24 months travel free provided they do not occupy a seat. Only one baby travelling free per adult. </p>
  },
  {
    question: 'Which classes are offered on my train? ',
    answer: <p>Classes are dependent on the route. Below are the classes offered on VIA by type of trip: </p>,
    table : 
            <div className="table-container-viafaq">
                <CustomCard className="my-bookings--card">
                    <table>
                        <thead>

                        </thead>
                        <tbody>
                            <tr>
                                <td>Ontario and Québec</td>
                                <td>Business class and Economy class</td>

                            </tr>
                            <tr>
                                <td>The Great Western Way (The Canadian)</td>
                                <td>Economy class,Sleeper Plus class,Prestige class</td>

                            </tr>
                            <tr>
                                <td>The Maritime Way</td>
                                <td>Sleeper Plus class and Economy class</td>

                            </tr>
                            <tr>
                                <td>The Adventure Routes</td>
                                <td>Sleeper Plus class,Economy class and Touring class</td>

                            </tr>

                        </tbody>
                    </table>
                </CustomCard>

            </div>
    },
  {
    question: 'How far in advance should I arrive to the train station?',
    answer: <p>We recommend passengers to be at the train station at least 30-minutes prior to the train departure. </p>
  },
  {
    question: `Are there any prohibited items that I can't take on VIA Rail?`,
    answer: <p><a href="https://www.viarail.ca/en/plan/baggages/prohibited-baggage" target="_blank" rel="noreferrer"> Prohibited items on VIA Rail</a></p>
  },
  
]
const onboardFaq = [
{
  question: `Do VIA Rail trains have dome cars?`,
  answer: <p>Passengers can enjoy the sweeping landscape views in the dome car on the following routes: Montreal to Halifax (The Ocean), Toronto to Vancouver (The Canadian) and Jasper to Prince Rupert (Touring Class only). </p>
},
{
  question: `Do VIA Rail trains have airconditioning and/or heating?`,
  answer: <p>Yes, all VIA passenger cars are fully heated and airconditioned.  </p>
},
{
  question: `Do VIA trains have WiFi?`,
  answer: <p>VIA Rail offers complimentary WiFi on most of it's trains and in business lounges as well as in certain station.  </p>
},
{
  question: `Are there any facilities for babies & toddlers onboard?`,
  answer: <p>VIA Rail offers priorty boarding for passengers travelling with toddlers. Restrooms are fitted with real changing tables and microwaves are available for baby bottles and purees.</p>
}
]

function ViaFaq() {
  const history = useHistory();
  const dispatch = useAppDispatch();

  return (
    <>
     <Helmet>
          <title>Rail Online - Buy Cheap Train Tickets in UK & Europe Online</title>
          <meta name="description" content="Rail Online is a quick & easy way to book cheap train tickets across UK & Europe. Take the scenic route with terrific deals on train tickets." />
          <link rel="canonical" href="https://www.rail.online/via"/>
        </Helmet>
      <div className="hero-image-container">
        <div className="background-shade d-none d-md-flex opacity-change"></div>
        <img className="img-fluid hero-image d-none d-md-flex" src={heroImage} alt="heroImage" />
        <div className="about-us-page--title">
          <h1>VIA FAQ's</h1>
          {/* <h2>Save on your UK train tickets by booking in advance.</h2> */}
        </div>
      </div>
      <div className="container-fluid max-width mb-5">
        <div className="common-page">
          <div className="common-page--content-area max-width about-us-page">
            

            <h3 className="mt-5 mb-3 text-left">Frequently Asked Questions</h3>
            <h3 className="mt-5 mb-3 text-left">Before departure</h3>

            {
              questions.map(({ question, answer, table }) => (
                <div key={question} className="qa-box">
                  <div className="qa-box--header">
                    <h4 className="p-2 p-md-3 pt-3 pb-3">{question}</h4>
                  </div>
                  <div className="p-2 p-md-3">{answer}</div>
                  <div className="p-2 p-md-3 text-align left">{table}</div>
                </div>
              ))
            }
             <h3 className="mt-5 mb-3 text-left">Onboard Experience</h3>

             {
              onboardFaq.map(({ question, answer }) => (
                <div key={question} className="qa-box">
                  <div className="qa-box--header">
                    <h4 className="p-2 p-md-3 pt-3 pb-3">{question}</h4>
                  </div>
                  <div className="p-2 p-md-3  width:100%  border:1px solid black;">{answer}</div>
                </div>
              ))
            }
            <h3 className="mt-5 mb-4">Ready to save on Via train tickets?</h3>
            <div className="d-flex w-100 justify-content-center">
              <CustomButton
                text="BOOK A TRIP"
                className="go-btn"
                onClick={() => {
                  dispatch(setSelectedSearchBoxTab('Train Tickets'));
                  history.push('/')
                }} />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ViaFaq
